import React, { Key, useEffect, useState } from 'react'
import './PaySlipAdminDetails.scss'

import productService from '../../../../../../Services/productService'
import { useParams } from 'react-router-dom'
import { ProductType } from 'Models/productType'
import { BreadCrumb } from 'Components'
import logo from 'Assets/Images/logo-dark.jpeg'
import paySlipService from 'Services/paySlipService'
import Swal from 'sweetalert2'
import { EmployeeType, payslipType } from 'Models'
import { CurrencyFormatter } from 'Helpers'
import { TimeConverter } from 'Helpers/TimeConverter'
import profileService from 'Services/profileService'

const PaySlipAdminDetails = () => {
  const { employeeId } = useParams<{ employeeId: string | undefined }>()
  const [pageNumber, setPage] = useState(1)

  const [productInformation, setProductInformation] = useState<{
    name: string
    id: string
  }>()

  const [payslip, setPayslip] = useState<Array<payslipType>>()
  const [payslipDetails, setPayslipDetails] = useState()

  const getPaySlip = async () => {
    await paySlipService.getPayslip(employeeId, pageNumber).then(
      (res) => {
        console.log('getPayslip', res.data.data)
        setPayslip(res.data.data.dataset)
      },
      (error) => {
        console.log('productService error', error.response)
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            cancelButton: 'btn btn-danger',
          },
          buttonsStyling: false,
        })

        swalWithBootstrapButtons.fire({
          title: 'Oops!',
          text: error.response.data.error,
          icon: 'warning',
          showCancelButton: true,
          showConfirmButton: false,
          cancelButtonText: 'close',
          reverseButtons: true,
        })
      },
    )
  }

  useEffect(() => {
    getPaySlip()
  }, [])

  const [profile, setProfile] = useState<EmployeeType>()

  const getProfile = async (userId: string) => {
    await profileService.getProfile(userId).then((response) => {
      console.log('profileService', response.data.data)
      setProfile(response.data.data)
    })
  }

  useEffect(() => {
    if (payslip && payslip[0]) {
      getProfile(payslip[0].userId)
    }
  }, [payslip])

  return (
    <div className='PaySlipAdminDetails'>
      <div className='container'>
        <BreadCrumb
          title={'Payslip details'}
          parent={'Payslip'}
          parentUrl={'admin/payslip-admin'}
          showTitle={false}
        ></BreadCrumb>
      </div>

      <div className='container mt-4'>
        <div className='container'>
          <div className='card border-0 px-4'>
            <div className='card-header bg-white pt-4 pb-3 px-0'>
              <h6 className='text-center'>Preview</h6>
              <div className='row  d-none'>
                <div className='col-md-9'>
                  <img src={logo} className='payslip-logo'></img>
                </div>
                <div className='col-md-3'>
                  <div className='address'>42, Concord Way. Local Airport Rd, Ikeja</div>
                  <div className='tel'>Tel: +234 908 779 2968</div>
                  <div className='email'>Email: support@thetradegrid.com</div>
                  <div className='email mt-3'>{payslip && TimeConverter(payslip[0].createdAt)}</div>
                </div>
              </div>
            </div>

            <div className='card-body px-0'>
              <div className='row mb-4'>
                <div className='col-sm-4 mb-2'>
                  <div className='name'>
                    {payslip && payslip[0].user.firstName + ' ' + payslip[0].user.lastName}
                  </div>

                  {/* <div className="address">
                    10 Maruwa Bus-stop, Lekki phase 1, Lagos.
                  </div>
                  <div className="tel">
                    E-mail: Samuelcoker@thetradegrid.com
                  </div>
                  <div className="email">Tel: 09036497986</div> */}
                </div>
                <div className='col-sm-4'></div>
                <div className='col-12 col-lg-4 d-none'>
                  <table className='table border w-100'>
                    <thead>
                      <tr>
                        <th>Pay day</th>
                        <th>Pay day</th>
                        <th>Period</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>26/01/24</td>
                        <td>MOnthly</td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className='table-responsive'>
                <table className='table table-striped'>
                  <thead>
                    <tr>
                      <th style={{ minWidth: 200 }}>Earning</th>
                      <th style={{ minWidth: 130 }}></th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {payslip &&
                      payslip[0].earnings.map(
                        (
                          res: {
                            amount: number
                            category: string
                          },
                          index: Key,
                        ) => {
                          return (
                            <tr key={index}>
                              <td>{res.category}</td>
                              <td></td>
                              <td>₦{CurrencyFormatter(res.amount)}</td>
                            </tr>
                          )
                        },
                      )}
                    <tr>
                      <td className='fw-bold'></td>
                      <td className='fw-bold'>Gross Pay</td>
                      <td className='fw-bold'>
                        ₦{payslip && CurrencyFormatter(payslip[0].totalEarnings)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className='table-responsive'>
                <table className='table table-striped'>
                  <thead className='custom-thead'>
                    <tr>
                      <th style={{ minWidth: 200 }}>Deductions</th>
                      <th></th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {payslip &&
                      payslip[0].deductions.map(
                        (
                          res: {
                            amount: number
                            category: string
                          },
                          index: Key,
                        ) => {
                          return (
                            <tr key={index}>
                              <td>{res.category}</td>
                              <td></td>
                              <td>₦{CurrencyFormatter(res.amount)}</td>
                            </tr>
                          )
                        },
                      )}
                    <tr>
                      <td className='fw-bold'></td>
                      <td className='fw-bold'>Total Deductions</td>
                      <td className='fw-bold'>
                        ₦{payslip && CurrencyFormatter(payslip[0].totalDeductions)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className='row justify-content-end'>
                <div className='col-md-7 ms-0 ps-0'>
                  <table className='table table-striped'>
                    <tbody>
                      <tr>
                        <td className='fw-bold'>Net Pay</td>
                        <td className='fw-bold'>
                          ₦{payslip && CurrencyFormatter(payslip[0].netPay)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PaySlipAdminDetails
